export const QUOTE_TEMPLATES = [
  {
    key: 'classic',
    name: 'Classic',
    description: 'Polished and versatile',
    tone: 'Violet accent',
  },
  {
    key: 'executive',
    name: 'Executive',
    description: 'Formal and assured',
    tone: 'Navy and gold',
  },
  {
    key: 'studio',
    name: 'Studio',
    description: 'Bold and editorial',
    tone: 'Warm coral',
  },
  {
    key: 'minimal',
    name: 'Minimal',
    description: 'Quiet and precise',
    tone: 'Monochrome',
  },
];

export const getQuoteTemplate = key =>
  QUOTE_TEMPLATES.find(template => template.key === key) ?? QUOTE_TEMPLATES[0];
